var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[(_vm.link==='interactiveTeaApp')?_c('InteractiveTeaApp',{attrs:{"props-id":_vm.link}}):_vm._e(),(_vm.link==='famousTeaSpecialarea')?_c('FamousTeaSpecialarea',{attrs:{"props-id":_vm.link}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }